<template>
  <div class="top">
    <!-- <img alt="log" src="@/assets/logo.png" class="log"> -->
    <img alt="log" src="@/assets/pda.svg" class="log">
    <div class="log_wrap">
      <div class="loginForm">
        <form>
          <input type="text" placeholder="请输入企业编码" v-model="enterpriseCode">
          <input placeholder="请输入账号" type="text" v-model="phone">
          <input placeholder="请输入密码" type="password" name="password" v-model="password" autocomplete>
        </form>
      </div>
      <div class="check_wrap">
        <van-checkbox v-model="checked_rember" @change="checked_remberPassword"
          checked-color="#ff4e00">记住密码</van-checkbox>
        <van-checkbox v-model="checked_auto" @change="checked_autoLogin" checked-color="#ff4e00">自动登录</van-checkbox>
      </div>
    </div>
    <button class="loginBtn" @click="login">登录</button>
  </div>
</template>
<style>
@import "../assets/css/login.css";
</style>
<script>
import { Toast } from "vant";
import md5 from "js-md5";
export default {
  name: "top",
  data() {
    return {
      phone: "",
      password: "",
      sign: "",
      userPassword: {},
      //存放所选选项
      checked_rember: true,
      checked_auto: false,
      enterpriseCode: "", // 企业编码
    };
  },
  mounted() {
    //记住密码
    this.enterpriseCode = localStorage.getItem('enterpriseCode') ? localStorage.getItem('enterpriseCode') : ""
    if (localStorage.getItem("FGuserPassword")) {
      this.checked_rember = true
      var userObject = JSON.parse(localStorage.getItem("FGuserPassword"))
      this.phone = userObject.phone || ''
      this.password = userObject.password || ''
      this.enterpriseCode = userObject.enterpriseCode || ""
    } else {
      this.checked_rember = false
    }
    //自动登录
    if (localStorage.getItem("checked_auto")) {
      this.checked_auto = true
    } else {
      this.checked_auto = false
    }
  },
  methods: {
    checked_remberPassword() {
      var userPassword = { phone: this.phone, password: this.password, enterpriseCode: this.enterpriseCode }
      if (this.checked_rember === false) {
        localStorage.removeItem("FGuserPassword");
      } else {
        if (this.phone === '' || this.password === '') {
          Toast('请输入完账号和密码');
          this.checked_rember = false
        } else {
          localStorage.setItem("FGuserPassword", JSON.stringify(userPassword));
        }
      }
    },
    //自动登录
    async checked_autoLogin() {
      if (this.checked_auto === false) {
        localStorage.removeItem("checked_auto");
      } else {
        localStorage.setItem("checked_auto", this.checked_auto);
        await this.loginTwo()
        this.login()
      }
    },
    loginTwo() {
      if (localStorage.getItem("FGuserPassword")) {
        var userObject = JSON.parse(localStorage.getItem("FGuserPassword"))
        this.phone = userObject.phone || ''
        this.password = userObject.password || ''
      } else {
        Toast('请先记住密码');
      }
    },
    PhoneCheck() {
      if (this.phone === "") {
        Toast({
          message: "请输入手机号",
          position: "bottom"
        });
        return false;
      }
      return true;
    },
    passCheck() {
      let pass = /^(\w){6,10}$/;
      if (!this.password) {
        Toast({
          message: "请输入密码",
          position: "bottom"
        });
        return false;
      }
      if (!pass.test(this.password)) {
        Toast({
          message: "密码不正确",
          position: "bottom"
        });
        return false;
      }
      return true;
    },
    async login() {
      localStorage.setItem('enterpriseCode', this.enterpriseCode)
      // if (this.enterpriseCode.length === 0) {
      //   Toast('请输入企业编码在登录!!')
      //   return
      // }else{
      //   let url = `http://${this.enterpriseCode}.lcyjfz.com/api`
      //   window.localStorage.setItem('pdaBASEURL' , url)
      // }
      if (this.PhoneCheck() && this.passCheck()) {
        /* 发起登陆请求 */
        let router = this.$router;
        let sign = md5(this.phone + this.password + "lcyj"); //传加密的值

        // if(this.enterpriseCode){
        //   link =` http://${this.enterpriseCode}.lcyjfz.com/api/business/pdaLogin`
        // }else{
        //   link = this.APIOBJ.BUSSINESS_LOGIN;
        // }

        let result_data = await this.post(this.APIOBJ.BUSSINESS_LOGIN, {
          name: this.phone,
          password: this.password
        });
        this.$store.commit("getusername", this.phone)
        let result = result_data.data
        if (result.status !== 1) {
          // 登陆失败
          Toast({
            message: result.msg,
            position: "bottom"
          });
        } else if (result.status === 1) {
          localStorage.setItem("userinfo", JSON.stringify(this.phone));
          router.push('/cards')
        }
      }
    },
    // created() {
    //   //记住密码
    //   console.log(localStorage.getItem("FGuserPassword"),'11111111111')
    //   if (localStorage.getItem("FGuserPassword")) {
    //     this.checked_rember = true
    //     var userObject = JSON.parse(localStorage.getItem("FGuserPassword"))
    //     this.phone = userObject.phone || ''
    //     this.password = userObject.password || ''
    //   } else {
    //     this.checked_rember = false
    //   }
    // }
  }
}
</script>
